var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return false
    ? _c(
        "div",
        {
          staticClass: "narrator",
          class: [
            _vm.shouldPanoramasListShow ? "narrator-up" : "",
            _vm.property.objectId ? "narrator-property" : "",
          ],
        },
        [
          _vm.showProfile
            ? _c("NarratorProfile", { attrs: { dataset: _vm.profile } })
            : _vm._e(),
          _vm._v(" "),
          _vm.showCalendarBtn
            ? _c("NarratorCalendarBtn", {
                attrs: { column: _vm.isFullWidth },
                on: { showCalendar: _vm.showCalendar },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.showGuideBtn
            ? _c("NarratorGuideBtn", {
                attrs: { column: _vm.isFullWidth },
                on: { showCalendar: _vm.showCalendar },
              })
            : _vm._e(),
          _vm._v(" "),
          _c("modal-booking", {
            ref: "ModalBooking",
            attrs: {
              company: _vm.profile.companyDisplayName || _vm.$t("None"),
              calendar: _vm.currentBuilding.calendar,
              bookings: _vm.currentBuilding.bookings,
            },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }